import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createLogger } from 'redux-logger';
import rootReducer from '../_reducers';

const loggerMiddleware = createLogger();

// Reducers that should NOT be persisted to localStorage. Every slice listed
// here is either:
//  - a large fetched list that is re-fetched on every page that needs it
//    (persisting it just bloats localStorage and slows cold-start hydrate), or
//  - transient UI state that should reset on app restart anyway.
//
// Anything not listed here keeps its existing persist-by-default behaviour.
// That specifically includes user/auth, in-progress booking state
// (hairdresserNewBooking*, selectHairdresserBookingDate/Time,
// clientBookingSlots, userBookingState, updateBookingInfo), user selections
// (selectedClient, selectedService, selectedServiceList, selectCheckoutItem,
// selectedCheckoutList, selectVoucher, selectedVoucherList), setting flags,
// bankDetails, createBooking, voucherByCode / voucherByRedemptionCode,
// salonOwnerDataInfo, static page content, marketing navigation state.
//
// Blacklist (not whitelist) is the safer shape for this change: any future
// reducer we add automatically keeps persisting by default (same as before),
// so forgetting to update this list preserves current behaviour.
const persistConfig = {
    key: 'root',
    storage,
    blacklist: [
        // Large fetched lists — always re-fetched on the relevant page
        'salonList',
        'hairdresserClient',
        'hairdresserClientCsv',
        'hairdresserClientListState',
        'upcomingOrPastBooking',
        'booking',
        'hairdresserBooking',
        'event',
        'staff',
        'staffService',
        'staffServiceDetail',
        'staffRota',
        'services',
        'hairdresserServices',
        'newServices',
        'voucherList',
        'payoutList',
        'cardReaderList',
        'hairdresserReview',
        'userReview',
        'salon',
        'hairdresser',
        'clientDetail',
        'categories',
        // Transient UI state — resets on app restart by design
        'alert',
        'dairyFilterData',
        'dairyStaffOrderList',
        'activeFilterStatus',
    ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

    let store = createStore(
        persistedReducer,
        applyMiddleware(
            thunkMiddleware,
            // loggerMiddleware
        )
    )
    let persistor = persistStore(store)
    export { store, persistor };


// export const store = createStore(
//     rootReducer,
//     applyMiddleware(
//         thunkMiddleware,
//         //loggerMiddleware
//     )
// );
